// AgentChats console layout switch. The assistant-ui rebuild is now the DEFAULT
// (cutover, SZ-1496). The legacy ConversationPanel stays reachable as a safety
// hatch via `?ui=legacy`; any other value (or no param) renders assistant-ui.
export function isAssistantUiEnabled(): boolean {
  if (typeof window === 'undefined') return true

  return new URLSearchParams(window.location.search).get('ui') !== 'legacy'
}

// The `ui` value to carry forward in navigation so the chosen layout sticks.
// Returns 'legacy' while in the legacy fallback, otherwise null — assistant-ui is
// the default and needs no param.
export function persistedUiParam(): 'legacy' | null {
  if (typeof window === 'undefined') return null

  return new URLSearchParams(window.location.search).get('ui') === 'legacy' ? 'legacy' : null
}
